import React, { useEffect } from 'react';
import { useLang } from '@/i18n/LanguageContext';

const JotformEmbed = ({ formId }) => {
  const { t } = useLang();

  useEffect(() => {
    const handleIframeMessage = (e) => {
      if (typeof e.data === 'string') {
        const args = e.data.split(':');
        if (args.length > 2) {
          const iframe = document.getElementById(`JotFormIFrame-${formId}`);
          if (!iframe) return;
          
          switch (args[0]) {
            case "setHeight":
              iframe.style.height = args[1] + "px";
              break;
            case "collapseErrorPage":
              if (iframe.clientHeight > window.innerHeight) {
                iframe.style.height = window.innerHeight + "px";
              }
              break;
            case "reloadPage":
              window.location.reload();
              break;
            case "loadScript":
              let src = args[1];
              if (args.length > 3) {
                  src = args[1] + ':' + args[2];
              }
              let script = document.createElement('script');
              script.src = src;
              script.type = 'text/javascript';
              document.body.appendChild(script);
              break;
            case "exitFullscreen":
              if (window.document.exitFullscreen) window.document.exitFullscreen();
              else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();
              else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();
              else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();
              else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
              break;
            default:
              break;
          }
        }
      }
    };

    window.addEventListener("message", handleIframeMessage);
    return () => window.removeEventListener("message", handleIframeMessage);
  }, [formId]);

  return (
    <section className="relative py-24 bg-slate-50 overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-full h-96 bg-brand-primary rounded-b-[4rem] md:rounded-b-[10rem] -z-0"></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-[13px] uppercase tracking-[0.2em] text-brand-secondary font-bold mb-3">
            {t.application?.kicker || "Join the Academy"}
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-white mb-6">
            {t.application?.title || "Official Application Form"}
          </h3>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            {t.application?.subtitle || "Complete the application below to secure your spot. A $50 application fee is required to submit your application."}
          </p>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-3xl shadow-2xl border border-slate-100 p-2 md:p-6 overflow-hidden min-h-[800px]">
          <iframe
            id={`JotFormIFrame-${formId}`}
            title="Application Form"
            onLoad={() => window.parent.scrollTo(0,0)}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src={`https://form.jotform.com/${formId}`}
            frameBorder="0"
            style={{ minWidth: '100%', height: '800px', border: 'none' }}
            scrolling="no"
          />
        </div>
      </div>
    </section>
  );
};

export default JotformEmbed;
